import Breadcrumb from "../components/Breadcrumb";
import CertificateOne from "../components/CertificateOne";
import ContactInner from "../components/ContactInner";
import FooterOne from "../components/FooterOne";
import FooterThree from "../components/FooterThree";
import FooterTwo from "../components/FooterTwo";
import Navbar from "../components/Navbar";


const ContactPage = () => {
  return (
    <>
      
      {/* Breadcrumb */}
      <Breadcrumb title={"Contact Us"} />

      {/* ContactInner */}
      <ContactInner />

      {/* CertificateOne */}
      {/* <CertificateOne /> */}

      {/* FooterOne */}
   
    </>
  );
};

export default ContactPage;
